'use client';

import Image from 'next/image';
import React from 'react';

import { IResolvedCard } from '@/src/utils/collections/cards.mapper';
import { CardTwoColumns } from '@/src/components/cards/CardTwoColumns/CardTwoColumns';
import { CardThreeColumns } from '@/src/components/cards/CardThreeColumns/CardThreeColumns';
import { CardOneColumn } from '@/src/components/cards/CardOneColumn/CardOneColumn';
import { ILocaleType } from '@/src/types';
import { IZoneWithDestinationsAndPromo } from '@/src/modules/destinations/destinations.modules';

interface IProps extends IResolvedCard {
  locale: ILocaleType;
  destinations?: Record<string, IZoneWithDestinationsAndPromo>;
}

export const Cards = ({
  layout,
  title,
  text,
  locale,
  destinations,
}: IProps) => {
  return (
    <div className="relative mx-auto w-full py-4 md:py-8 lg:py-22.5">
      {layout.type === 'three' && (
        <Image
          src={'/static/icons/title-decoration-yellow.svg'}
          alt="background-shape"
          width={450}
          height={300}
          className="decoration-visible absolute left-0 top-[150px] -z-10 hidden w-[300px] opacity-25 lg:top-[50px] lg:w-[450px] xl:w-[600px] 2xl:w-[700px]"
        />
      )}
      <div className={'mx-auto max-w-1200 py-4 md:py-8 lg:py-22.5'}>
        {title && (
          <div
            className={'mb-15 text-center text-4xl font-semibold lg:text-6xl'}
          >
            {title}
          </div>
        )}
        {text && (
          <div
            className={
              'mb-4 text-center text-lg font-semibold md:text-xl lg:text-2xl'
            }
          >
            {text}
          </div>
        )}

        {layout.type === 'one' && (
          <CardOneColumn
            destinations={destinations}
            item={layout.data.item}
            locale={locale}
          />
        )}
        {layout.type === 'two' && (
          <CardTwoColumns
            items={layout.data.items}
            locale={locale}
            destinations={destinations}
            positionDesktop={layout.data.positionDesktop}
            positionMobile={layout.data.positionMobile}
            backgroundColor={layout.data.backgroundColor}
          />
        )}
        {layout.type === 'three' && (
          <CardThreeColumns
            title={title}
            text={text}
            items={layout.data.items}
            action={layout.data.action}
            destinations={destinations}
            locale={locale}
          />
        )}
      </div>
    </div>
  );
};
